/**
 * @fileoverview POST handler for the "/internal_user_groups/bulk_add_users_to_group_v2/:app_group_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appSettingsInternalUserGroupsBulkAddUsersToGroupV2AppGroupIdCacheKeys } from "./constants";
import type {
  PostAppSettingsInternalUserGroupsBulkAddUsersToGroupV2AppGroupIdProps,
  AppSettingsInternalUserGroupsBulkAddUsersToGroupV2AppGroupIdResult,
} from "./types";

export const postAppSettingsInternalUserGroupsBulkAddUsersToGroupV2AppGroupId = reactQueryMutationAdapter(
  appSettingsInternalUserGroupsBulkAddUsersToGroupV2AppGroupIdCacheKeys,
  ({
    appGroupId,
    internalUserGroupId,
    existingUsers,
  }: PostAppSettingsInternalUserGroupsBulkAddUsersToGroupV2AppGroupIdProps): Promise<AppSettingsInternalUserGroupsBulkAddUsersToGroupV2AppGroupIdResult> => {
    const props = {
      internal_user_group_id: internalUserGroupId,
      existing_users: existingUsers.map(({ id, testUserName }) => ({ id, test_user_name: testUserName })),
    };

    return fetch(`/internal_user_groups/bulk_add_users_to_group_v2/${appGroupId}`, "POST", props, undefined, {
      // don't display a modal on fetch errors
      propagateFetchRequestError: false,
    });
  }
);
